export const ADDRESS_SEARCH_FETCH_REQUEST = "ADDRESS_SEARCH_FETCH_REQUEST";
export const ADDRESS_SEARCH_FETCH_SUCCESS = "ADDRESS_SEARCH_FETCH_SUCCESS";
export const ADDRESS_SEARCH_FETCH_FAILURE = "ADDRESS_SEARCH_FETCH_FAILURE";
export const ADDRESS_SPLIT_FETCH_REQUEST = "ADDRESS_SPLIT_FETCH_REQUEST";
export const ADDRESS_SPLIT_FETCH_SUCCESS = "ADDRESS_SPLIT_FETCH_SUCCESS";
export const ADDRESS_SPLIT_FETCH_FAILURE = "ADDRESS_SPLIT_FETCH_FAILURE";
export const ADDRESS_SEARCH = "ADDRESS_SEARCH";
